/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/jsx-fragments */
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import FilterListIcon from '@mui/icons-material/FilterList'
import Tooltip from '@mui/material/Tooltip'

import { Button, Stack } from '@mui/material'
import * as S from './styles'

function FilterButton({ notifications, handleClick, loading }) {
  return (
    <Stack ml="auto" position="relative" data-id="filterButton" data-testid="filterButton" onClick={handleClick}>
      {notifications > 0 && <S.Notification>{notifications}</S.Notification>}
      <Tooltip title="Filtro" placement="top">
        <Fragment>
          <Button
            onClick={handleClick}
            variant="outlined"
            data-testid="filter"
            disabled={loading}
            sx={{
              background: '#00AEEF1C',
              color: '#00AEEF',
              border: 'none',
              ':hover': {
                background: '#00AEEF1C',
                color: '#00AEEF',
                border: 'none',
              },
              '&.Mui-disabled': {
                backgroundColor: '#eaeaea',
                color: '#c0c0c0',
                border: 'none',
              },
            }}
          >
            <FilterListIcon
              sx={{
                marginRight: '8px',
                color: loading ? 'disabled' : 'primary',
              }}
            />
            Filtros
          </Button>
        </Fragment>
      </Tooltip>
    </Stack>
  )
}

FilterButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  notifications: PropTypes.number,
  loading: PropTypes.bool,
}
FilterButton.defaultProps = {
  notifications: 0,
  loading: false,
}

export default FilterButton
